// extracted by mini-css-extract-plugin
module.exports = {"introContent":"RelatedPosts_introContent__rC_B_","grid":"RelatedPosts_grid__6I_Hu","column":"RelatedPosts_column__CatHL","cols-half":"RelatedPosts_cols-half__S3xN3","cols-thirds":"RelatedPosts_cols-thirds___Q5VW"};
module.exports.__checksum = "387286035c52"
